// extracted by mini-css-extract-plugin
export default {"root":"root___RrL0M","block":"block___HX97U"};